import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { asapScheduler, EMPTY, forkJoin, Subscription } from 'rxjs';

import { IUserHistory } from '@soleran/audit';
import { IModule } from '@soleran/module';

import { NavService } from '../nav/nav.service';
import { AdvancedSearchService } from './advanced-search/advanced-search.service';
import { GlobalSearchService } from './global-search.service';
import { IRecordSearchResult } from './record-search-result';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss'],
})
export class GlobalSearchComponent implements OnInit {
  isBusy: boolean = false;
  term: string = '';

  records: IRecordSearchResult[] = [];
  histories: IUserHistory[] = [];

  private _modules: IModule[] = [];
  private _searchSub = new Subscription();
  private _subs = new Subscription();

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _nav: NavService,
    private _gs: GlobalSearchService,
    private _as: AdvancedSearchService
  ) {}

  ngOnInit(): void {
    this._handleClearOnNavigation();
    this._initViewData();
  }

  ngOnDestroy(): void {
    this._searchSub.unsubscribe();
    this._subs.unsubscribe();
  }
  onSearchValueChange(term: string) {
    this._searchSub.unsubscribe();
    this.term = term;
    this.isBusy = true;
    this.records = [];
    this._searchSub = this._search().subscribe({
      next: (r) => {
        this.records.push(r);
        this.records.orderBy((v) => v.module.name as any);
      },
      complete: () => {
        this.isBusy = false;
      },
    });
  }

  onViewAllRecordsClick() {
    (this._document.activeElement as any).blur();
    asapScheduler.schedule(() => this._as.open({ term: this.term }), 50);
    this._searchSub.unsubscribe();
  }

  private _handleClearOnNavigation() {
    this._subs.add(this._nav.start().subscribe((s) => this._clearAndClose()));
  }
  private _clearAndClose() {
    this.term = '';
    (this._document.activeElement as any).blur();
  }
  private _search() {
    return this.term
      ? this._gs.get({
          searchText: this.term,
          moduleIds: this._modules.map((m) => m.id),
          maxResultsPerModule: 10,
          maxResults: 10,
        })
      : EMPTY;
  }
  private _initViewData() {
    this._subs.add(
      forkJoin({
        histories: this._gs.getHistory(),
        modules: this._gs.getAppModules(),
      }).subscribe((d) => {
        this._modules = d.modules;
        this.histories = d.histories;
      })
    );
  }
}
